module.exports = __webpack_public_path__ + "static/img/dlb_rz-2.84bf64d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dlb_rz-2.png
// module id = TH/U
// module chunks = 0